var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      class: [_vm.$style["mds-radio-button"], _vm.classObject, _vm.sizeClass],
      attrs: { "data-mds-version": _vm.version },
    },
    [
      _c(
        "input",
        _vm._b(
          {
            class: _vm.$style["mds-radio-button__input"],
            attrs: { name: _vm.name, type: "radio", disabled: _vm.disabled },
            domProps: { value: _vm.value, checked: _vm.isChecked },
            on: {
              change: function ($event) {
                return _vm.toggleCheck($event)
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("span", { class: _vm.$style["mds-radio-button__visible-wrap"] }, [
        _c("span", { class: _vm.$style["mds-radio-button__visual"] }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                focusable: "false",
                "aria-hidden": "true",
              },
            },
            [
              _c("circle", {
                class: _vm.$style["mds-radio-button__visual-outer"],
                attrs: { cx: "12", cy: "12", r: "11" },
              }),
              _vm._v(" "),
              _c("circle", {
                class: _vm.$style["mds-radio-button__visual-check"],
                attrs: { cx: "12", cy: "12", r: "8.5" },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { class: _vm.$style["mds-radio-button__text"] },
          [
            _vm._t("default", function () {
              return [_vm._v(_vm._s(_vm.label))]
            }),
            _vm._v(" "),
            _vm.microcopy || _vm.hasMicrocopySlotContent
              ? _c(
                  "span",
                  { class: _vm.$style["mds-radio-button__microcopy"] },
                  [
                    _vm._t("mds-microcopy", function () {
                      return [
                        _vm.microcopy
                          ? _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.microcopy) },
                            })
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }